export default {
  meta: {
    title: $localize`:@@meta.double.history.title:История double`,
    description: $localize`:@@meta.double.history.desc:Ищешь крупные иксы на свои скины csgo? Убедись в том, что у нас самые высокие коэффициенты из всех классических режимов double CS:GO с помощью этой страницы.`
  }
};